import { useState } from "react";
import Pagination from "@mui/material/Pagination";

import useFilters from "core/hooks/useFilters";
import { useDebounceCallback } from "core/hooks/useDebounce";

import Box from "ui/atom/Box";
import Button from "ui/base/Button";
import Input from "ui/base/Input";
import Tabs from "ui/base/Tabs";
import Page from "ui/Page";
import Table from "ui/Table";

import { useContents } from "../fabric";


Contents.Tabs = () => {
	const { filters, setFilters } = useFilters("/content/");
	const tab = filters.type || "all";

	return (
		<Tabs value={tab} onChange={(_, type: "all" | "featured") => setFilters({ type, page: 1 })} variant="fullWidth" textColor="secondary" indicatorColor="secondary">
			<Tabs.Tab label="All" value="all" />
			<Tabs.Tab label="Featured" value="featured" />
		</Tabs>
	);
};

Contents.Table = () => {
	const contents = useContents();
	const showPagination = contents.query.data?.values && contents.query.data?.values?.length > 0;

	return (
		<Box.Column gap={2} sx={{ mt: 2 }}>
			<Table columns={contents.columns} data={contents.query.data?.values} icon="list-todo" />
			{showPagination && <Pagination siblingCount={0} page={contents.query.data?.pagination?.Page || 1} count={contents.query.data?.pagination?.Pages} color="secondary" onChange={(_, page) => contents.setFilters({ page })} />}
		</Box.Column>
	);
};

Contents.Filter = () => {
	const contents = useContents();
	const [value, setValue] = useState(contents.filters.search || "");
	const debounce = useDebounceCallback((search) => contents.setFilters({ search }));

	const handleSearch = (search: string) => {
		setValue(search);
		debounce(search);
	};

	return <Input
		value={value}
		onChange={(e) => handleSearch(e.target.value)}
		endAdornment={<Button.Icon icon="circle-x" onClick={() => handleSearch("")} sx={{ p: 0 }} />}
		placeholder="Search for the title or URL"
	/>;
};

export default function Contents() {

	return (
		<Page>
			<Page.Header title="Articles" />
			<Page.Body>
				<Contents.Tabs />
				<Contents.Filter />
				<Contents.Table />
			</Page.Body>
		</Page>
	);
}